module.exports = __webpack_public_path__ + "img/8_36.896bab2d.png";